import api from './api';

export const crearAsiento = async (payload) => {
  const response = await api.post('/api/asientos', payload);
  return response.data;
};

export const listarAsientos = async ({ id_company, anio, mes, cuenta, origen, page = 1, limit = 20 }) => {
  const response = await api.get('/api/asientos', {
    params: { id_company, anio, mes, cuenta, origen, page, limit },
  });
  return response.data;
};

export const obtenerGrupoAsiento = async (idAsientoGrupo) => {
  const response = await api.get(`/api/asientos/grupo/${idAsientoGrupo}`);
  return response.data;
};

export const editarGrupoAsiento = async (idAsientoGrupo, payload) => {
  const response = await api.put(`/api/asientos/grupo/${idAsientoGrupo}`, payload);
  return response.data;
};

export const obtenerCuentas = async () => {
  const response = await api.get('/api/clasificador-cuentas');
  return response.data;
};
